import React from "react";

import { ColorPage } from "./ColorPage";
import { ConfirmationPage } from "./ConfirmationPage";
import { LocationPage } from "./LocationPage";
import { MultipleOptionsPage } from "./MutipleOptionsPage";
import { SingleOptionPage } from "./SingleOptionPage";
import { Question, QuestionDefinitionDto, QuestionType } from "./questionaire-types";

type QuestionairePageProps = {
  questionDefinition: QuestionDefinitionDto;
  onNext: (question: Question) => void;
  isSaving: boolean;
  isFrenchLanguage:boolean;
};

export const QuestionairePage = ({ questionDefinition,isFrenchLanguage, onNext, isSaving }: QuestionairePageProps) => {
  const pages = {
    [QuestionType.Location]: () => <LocationPage questionDefinition={questionDefinition} onNext={onNext} isFrenchLanguage={isFrenchLanguage} />,
    [QuestionType.Single]: () => <SingleOptionPage key={questionDefinition.key} questionDefinition={questionDefinition} onNext={onNext} isSaving={isSaving} isFrenchLanguage={isFrenchLanguage} />,
    [QuestionType.Multiple]: () => (
      <MultipleOptionsPage key={questionDefinition.key} questionDefinition={questionDefinition} onNext={onNext} isSaving={isSaving} isFrenchLanguage={isFrenchLanguage} />
    ),
    [QuestionType.Color]: () => <ColorPage questionDefinition={questionDefinition} onNext={onNext} isSaving={isSaving} isFrenchLanguage={isFrenchLanguage} />,
    [QuestionType.Confirmation]: () => <ConfirmationPage questionDefinition={questionDefinition} onNext={onNext} isSaving={isSaving} isFrenchLanguage={isFrenchLanguage} />,
  };
  type KeyOfPages = keyof typeof pages;

  return pages[questionDefinition.questionType as KeyOfPages]();
};
